// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/image/expanded.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/image/collapsed.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#layout-container {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  /*四个基准坐标样式 上右下左*/
}
#layout-container #header-container {
  padding: 0 10px;
  height: 50px;
  line-height: 50px;
  font-size: 24px;
  color: white;
  background-color: #4778c7;
}
#layout-container #header-container .system {
  float: left;
  width: 300px;
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  font-weight: bold;
  color: white;
}
#layout-container #header-container .system img {
  margin-top: -3px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
#layout-container #header-container .toolbar {
  float: right;
  height: 50px;
  line-height: 50px;
  text-align: right;
  font-size: 13px;
  color: white;
}
#layout-container #header-container .toolbar img {
  border: none;
  cursor: pointer;
}
#layout-container #header-container .toolbar select {
  width: 100px;
  color: white;
  border: 1px solid #6895dd;
  background: #4778c7;
  overflow: hidden;
}
#layout-container #header-container .toolbar select:hover {
  border: 1px solid #97b9f0;
}
#layout-container #module-container {
  /*IE7--begin*/
  width: 100%;
  /*IE7--end*/
  color: white;
  background-color: #344462;
}
#layout-container #module-container #module-left {
  position: relative;
  float: left;
  width: 200px;
  line-height: 33px;
  text-align: center;
  font-size: 12px;
  color: #d1d9e7;
}
#layout-container #module-container #module-left .thumb {
  position: absolute;
  top: 8px;
  left: 16px;
  font-size: 16px;
  cursor: pointer;
}
#layout-container #module-container #module-right {
  float: right;
  width: 0;
  text-align: left;
  font-weight: bold;
  color: white;
}
#layout-container #module-container #module {
  float: left;
  line-height: 36px;
}
#layout-container #module-container #module .item {
  float: left;
  margin-right: 2px;
  width: 90px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 13px;
  color: white;
  cursor: pointer;
}
#layout-container #module-container #module .item:hover {
  color: white;
  background-color: #2b384f;
}
#layout-container #module-container #module .selected {
  float: left;
  margin-right: 3px;
  width: 90px;
  height: 33px;
  line-height: 30px;
  text-align: center;
  color: white;
  font-size: 13px;
  font-weight: bold;
  border-top: 3px solid #f25f0f;
  background: #2b384f;
  cursor: pointer;
}
#layout-container #menu-container {
  position: absolute;
  overflow: auto;
  width: 200px;
  border-right: 1px #99BBE8 solid;
  background: #4778c7;
  /*按菜单级别动态调整边框和背景色*/
}
#layout-container #menu-container .mc {
  display: none;
}
#layout-container #menu-container .m1 {
  position: relative;
  padding-left: 20px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: white;
  border-bottom: 1px solid #182432;
  background: #1b2737;
  cursor: pointer;
}
#layout-container #menu-container .m2 {
  padding-left: 30px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: white;
  border-bottom: 1px solid #1d2b3d;
  background: #223145;
  cursor: pointer;
  position: relative;
}
#layout-container #menu-container .m3 {
  position: relative;
  padding-left: 40px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: white;
  border-bottom: 1px solid #203043;
  background: #2e4461;
  cursor: pointer;
}
#layout-container #menu-container .m4 {
  position: relative;
  padding-left: 50px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: white;
  border-bottom: 1px solid #203043;
  background: #3e5a82;
  cursor: pointer;
}
#layout-container #menu-container .m5 {
  position: relative;
  padding-left: 60px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: white;
  border-bottom: 1px solid #325987;
  background: #4c71a5;
  cursor: pointer;
}
#layout-container #menu-container .m {
  position: relative;
  padding-left: 70px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: white;
  border-bottom: 1px solid #3b6391;
  background: #5b8aca;
  cursor: pointer;
}
#layout-container #menu-container .m1fix {
  border-color: #182432;
  background-color: #1b2737;
}
#layout-container #menu-container .m2fix {
  border-color: #1d2b3d;
  background-color: #223145;
}
#layout-container #menu-container .m3fix {
  border-color: #203043;
  background-color: #2e4461;
}
#layout-container #menu-container .m4fix {
  border-color: #203043;
  background-color: #3e5a82;
}
#layout-container #menu-container .m5fix {
  border-color: #325987;
  background-color: #4c71a5;
}
#layout-container #menu-container .mfix {
  border-color: #3b6391;
  background-color: #5b8aca;
}
#layout-container #menu-container .selected {
  border-left: 3px solid #f25f0f;
}
#layout-container #menu-container .m1:hover {
  filter: alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
}
#layout-container #menu-container .m2:hover {
  filter: alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
}
#layout-container #menu-container .m3:hover {
  filter: alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
}
#layout-container #menu-container .m4:hover {
  filter: alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
}
#layout-container #menu-container .m5:hover {
  filter: alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
}
#layout-container #menu-container .m:hover {
  filter: alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
}
#layout-container #menu-container span.expanded {
  position: absolute;
  right: 0;
  width: 20px;
  height: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: left center;
  /*IE7*/
  *background-position: left 20%;
  background-repeat: no-repeat;
}
#layout-container #menu-container span.collapsed {
  position: absolute;
  right: 0;
  width: 20px;
  height: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: left center;
  /*IE7*/
  *background-position: left 20%;
  background-repeat: no-repeat;
}
#layout-container #menu-container .thumb {
  line-height: 30px;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: 500;
}
#layout-container #work-container {
  position: absolute;
  overflow-x: hidden;
  overflow-y: auto;
}
#layout-container #footer-container {
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  color: #d1d9e7;
  background: #405377;
}
#layout-container #p1 {
  position: absolute;
  top: 0;
  overflow: hidden;
  width: 0;
  height: 0;
  background: red;
}
#layout-container #p2 {
  position: absolute;
  right: 0;
  overflow: hidden;
  width: 0;
  height: 0;
  background: red;
}
#layout-container #p3 {
  position: absolute;
  bottom: 0;
  overflow: hidden;
  width: 0;
  height: 0;
  background: red;
}
#layout-container #p4 {
  position: absolute;
  left: 0;
  overflow: hidden;
  width: 0;
  height: 0;
  background: red;
}
#layout-container #mtree {
  position: absolute;
  overflow: auto;
  z-index: 999999999;
  padding: 10px 10px 10px 5px;
  width: 195px;
  height: 100%;
  background: #4778c7;
  display: none;
}
#layout-container #mtree .el-tree {
  font-size: 12px;
  color: white;
  background: #4778c7;
}
#layout-container #mtree .el-tree-node__content:hover {
  background: #89c2f7;
}
#layout-container #mtree .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: white;
  background-color: #89c2f7;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
